import { sortBy } from 'lodash';
import React from 'react';

import { useI18n } from '../../../../../data/hooks/i18nHooks';
import LoadSpeakers from '../../../../loaders/LoadSpeakers';
import SpeakerCard from './SpeakerCard';
import styles from './SpeakersMosaic.module.scss';

const SpeakersMosaic = (props) => {
    const { event, session } = props,
        speakers = sortBy(session.speakers, 'in_item_order'),
        i18n = useI18n();

    return (
        <LoadSpeakers eventId={event.id}>
            {/*<div className={styles.MosaicWrapper}>*/}
            <div className={[styles.SpeakersMosaic].join(' ')}>
                {speakers.map((speaker, i) => (
                    <SpeakerCard key={i} event={event} speaker={speaker} i18n={i18n} />
                ))}
            </div>
            {/*</div>*/}
        </LoadSpeakers>
    );
};

export default SpeakersMosaic;
